import {createContext} from 'react';
import type {FeedbackAPI} from '@/feedback/services/FeedbackAPI';

export const ServicesContext = createContext<{
	feedbackAPI: FeedbackAPI;
} | null>(null);

ServicesContext.displayName = 'ServicesContext';
